import { render } from "./Upcoming.vue?vue&type=template&id=25e76a9b"
import script from "./Upcoming.vue?vue&type=script&lang=js"
export * from "./Upcoming.vue?vue&type=script&lang=js"

import "./Upcoming.vue?vue&type=style&index=0&id=25e76a9b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__